import type { ComponentType } from 'react';

import Loadable from 'react-loadable';

import type { FeedbackCollectorProps } from './types';

const FeedbackDialogLazy: ComponentType<FeedbackCollectorProps> & Loadable.LoadableComponent =
	Loadable({
		loader: () => import(/* webpackChunkName: "async-ptc_feedback-dialog" */ './FeedbackCollector'),
		loading: () => null,
	});
FeedbackDialogLazy.displayName = 'lazy(FeedbackDialog)';

export default FeedbackDialogLazy;
